import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { scrollX } from '@finect/tabular-utils/scrollX';
import { getFont } from '@finect/tabular-utils/getFont';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-4obtd2-0"
})(["margin-bottom:12px;"]);
export var Title = styled.h2.withConfig({
  displayName: "partials__Title",
  componentId: "sc-4obtd2-1"
})(["", " font-weight:600;margin-bottom:18px;"], getFont(3));
export var EvergreenArticlesBlock = styled.div.withConfig({
  displayName: "partials__EvergreenArticlesBlock",
  componentId: "sc-4obtd2-2"
})(["margin-top:16px;", ""], minMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-top: 0;\n  "]))));
export var ProductsBlock = styled.div.withConfig({
  displayName: "partials__ProductsBlock",
  componentId: "sc-4obtd2-3"
})(["margin-top:64px;"]);
export var ProductsGrid = styled.div.withConfig({
  displayName: "partials__ProductsGrid",
  componentId: "sc-4obtd2-4"
})(["", " ", ""], maxMediaQueries.phone(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    ", "\n\n    > div {\n      max-width: 200px;\n\n      :not(:last-child) {\n        margin-right: 16px;\n      }\n    }\n  "])), scrollX), minMediaQueries.phone(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: grid;\n    gap: 16px;\n    grid-template-columns: repeat(5, 1fr);\n  "]))));
export var Hr = styled.hr.withConfig({
  displayName: "partials__Hr",
  componentId: "sc-4obtd2-5"
})(["height:4px;border-style:none;border-radius:", ";margin:64px 0;background-color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.ui;
});